import "./art_carousel.scss";

import { Icon } from "@components/icon";
import React, { type FC } from "react";

interface PrevButtonProps {
  previous: () => void;
}

const PrevButton: FC<PrevButtonProps> = ({ previous }) => {
  const handleClick = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    previous();
  };

  return (
    <a
      aria-label="Previous"
      title="Previous"
      href="#"
      className="secondary art-window--prev"
      onClick={handleClick}
    >
      <Icon name="circle-left" />
    </a>
  );
};

interface NextButtonProps {
  next: () => void;
}

const NextButton: FC<NextButtonProps> = ({ next }) => {
  const handleClick = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    next();
  };

  return (
    <a
      aria-label="Next"
      title="Next"
      href="#"
      className="secondary art-window--next"
      onClick={handleClick}
    >
      <Icon name="circle-right" />
    </a>
  );
};

interface CloseButtonProps {
  close: () => void;
}

const CloseButton: FC<CloseButtonProps> = ({ close }) => {
  const handleClick = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    close();
  };

  return (
    <a
      aria-label="Close"
      title="Close"
      href="#"
      className="secondary art-window--close"
      onClick={handleClick}
    >
      <Icon name="cross" />
    </a>
  );
};

export {
  CloseButton,
  type CloseButtonProps,
  NextButton,
  type NextButtonProps,
  PrevButton,
  type PrevButtonProps,
};
